import Rete, { Socket} from "rete";
import VueStringControl from "./StringControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class StringControl extends Rete.Control {
  constructor(emitter, key, readonly) {
    super(key);
    this.render = "vue";
    this.component = VueStringControl;
    this.props = { emitter, ikey: key, readonly };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}

const StringSocket = new Socket("String");
StringSocket.combineWith(AnyTypeSocket);
export { StringSocket };